module.exports = __webpack_public_path__ + "static/img/1.1c65d8c2.jpg";